export const tableData: AuditTableEntry[] = [
  {
    testid: 'test',
    testPass: false,
    title: 'test',
    category: 'test',
    definitionMarkdown: 'test',
    testMarkdown: 'test',
    resultMarkdown: 'test',
    resultList: ['test', 'test1'],
    solutionMarkdown: 'test',
    solutionList: ['test', 'test1'],
    gaLink: 'None',
  },
]

tableData[1] = tableData[0]
tableData[2] = tableData[0]
tableData[3] = tableData[0]
tableData[4] = tableData[0]

export default JSON.stringify({
  data: {
    tableData,
    token: 'mocked-token-updated',
  },
})
